import { all, put } from 'redux-saga/effects'
import { readMessagesFromChatAction } from '../../handles'
import { read, update } from '../_http/chat'

export function* readMessagesFromChatSaga(action: ReturnType<typeof readMessagesFromChatAction.request>) {
  const { chat } = action.payload
  try {
    yield put(readMessagesFromChatAction.success({ ...chat, unreadMessagesCount: 0 }))
    yield all([update(chat.id, { unreadMessagesCount: 0 }), read(chat.id)])
  } catch (error) {
    console.log({ readMessagesFromChatSaga: error })
    yield put(readMessagesFromChatAction.failure(chat))
  }
}
